import { BrowserRouter, Routes, Route } from "react-router-dom";

import Home from "./components/Home";
import Imprint from "./components/legal/Imprint";
import PrivacyPolicy from "./components/legal/PrivacyPolicy";

const App = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/imprint" element={<Imprint />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;
